import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ProofRequirementModel } from 'src/lib/services/api/users/update-request/users-update-request.model';
import { ModalService } from 'src/lib/services/utility/modal/modal.service';
import { UploadProofModalComponent } from './upload-proof-modal.component';

@Injectable({
	providedIn: 'root',
})
export class UploadProofModalService {
	constructor(private modalService: ModalService) {}

	public openModal$(proofMap: Map<string, ProofRequirementModel>) {
		return new Observable<{ ids: string[]; file: File }[]>((o) => {
			const ngbModalOptions: NgbModalOptions = {
				backdrop: 'static',
				size: 'md',
			};

			const modal = this.modalService.open(
				UploadProofModalComponent,
				ngbModalOptions,
				{ proofMap },
			);

			modal.result
				.then((x) => {
					o.next(x);
					o.complete();
				})
				.catch(() => {
					o.next(null);
					o.complete();
				});
		});
	}
}
